/* eslint-disable react-hooks/exhaustive-deps */
import {
  Button,
  Card,
  Col,
  Collapse,
  Container,
  Form,
  Row,
  Table
} from 'react-bootstrap'
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom'
import { BadgeStatusPrLists } from '../../../components/atoms/StatusLabel'
import {
  ChevronDown,
  ChevronUp,
  Download,
  History,
  FileText
} from 'lucide-react'
import { convertDateWithTime } from '../../../helpers/constants'
import ModalPrDetailTimeline from '../../../components/modal/ReceiveAtWarehouse/PrDetailTimeline'
import Loading from '../../../components/atoms/Loading'
import * as Common from '../../../utils/Common'
import api from '../../../config/AxiosInstance'
import Swal from 'sweetalert2'
import { useEffect, useState } from 'react'
import toast, { Toaster } from 'react-hot-toast'

const cardStyle = {
  border: 'none',
  boxShadow: '0 2px 12px rgba(0,0,0,0.04)',
  borderRadius: '12px',
  padding: '1.5rem',
  marginBottom: '1.5rem',
  backgroundColor: '#fff'
}

const labelDetailStyle = {
  fontSize: '0.75rem',
  fontWeight: '700',
  color: '#999',
  textTransform: 'uppercase',
  marginBottom: '0.25rem',
  letterSpacing: '0.5px'
}

const tableHeaderStyle = {
  fontSize: '14px',
  fontWeight: '600',
  color: '#333333',
  letterSpacing: '0.5px',
  backgroundColor: '#f8f9fa',
  borderBottom: '2px solid #e9ecef'
}

const StyledDetailField = ({ label, value, col = 3, children }) => {
  return (
    <Form.Group className={`mb-3 col-12 col-md-${col}`}>
      <Form.Label style={labelDetailStyle}>{label}</Form.Label>
      <div
        className="px-0"
        style={{
          fontSize: '0.9rem',
          fontWeight: '500',
          color: '#212529',
          minHeight: '24px'
        }}
      >
        {children ? children : value}
      </div>
    </Form.Group>
  )
}

function InboundReturnDetail() {
  const { id } = useParams()
  const { state } = useLocation()
  const navigate = useNavigate()

  const statusTextMapping = {
    unassigned: 'unassigned',
    waiting_rnr: 'waiting rnr',
    receiving_progress: 'receiving progress',
    rnr: 'receiving progress',
    waiting_om: 'waiting om',
    request_pnp: 'waiting om',
    waiting_pnp: 'waiting pnp',
    pnp: 'put away',
    put_away: 'put away',
    done: 'done',
    revised: 'waiting rnr'
  }

  const [itemCoaCollapse, setItemCoaCollapse] = useState(true)
  const [data, setData] = useState({
    id: null,
    code: null,
    erp_doc: null,
    series_number: null,
    rr: null,
    target_warehouse: null,
    driver: null,
    status: null,
    items: [],
    stagings: [],
    receipt_details: [],
    created_by: null,
    created_at: null,
    updated_by: null,
    updated_at: null
  })
  const [showModalTimeline, setShowModalTimeline] = useState(false)
  const [prTimelineId, setPrTimelineId] = useState(null)
  const [loading, setLoading] = useState({
    page: false,
    download: {}
  })
  const handleDownloadLabel = async (valueId) => {
    try {
      setLoading((prevLoading) => ({
        ...prevLoading,
        download: {
          ...prevLoading.download,
          [valueId]: true
        }
      }))
      const payload = {
        inbound_staging_id: valueId
      }
      const res = await api.post(`inbound/return/${id}/label`, payload, {
        responseType: 'arraybuffer'
      })
      const { status, data: dataResponse } = res
      if (status === 200) {
        const blob = new Blob([dataResponse], { type: 'application/pdf' })
        const url = window.URL.createObjectURL(blob)

        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', `download-label-${valueId}.pdf`)
        document.body.appendChild(link)
        link.click()

        document.body.removeChild(link)
        window.URL.revokeObjectURL(url)
      }
    } catch (error) {
      const err =
        error?.response?.data?.errors?.message ||
        error?.message ||
        'An error occurred'
      Common.showPopUpErrorMessage(err)
    } finally {
      setLoading((prevLoading) => ({
        ...prevLoading,
        download: {
          ...prevLoading.download,
          [valueId]: false
        }
      }))
    }
  }
  const columnItemCOA = [
    { key: 'sequence', label: 'No' },
    {
      key: 'item_code_name',
      label: 'Item Code - Name',
      component: (item) => `${item.item_code} - ${item.item_name}`
    },
    { key: 'batch', label: 'Batch' },
    {
      key: 'total_qty',
      label: 'Base Qty UOM',
      component: (item) => `${item.total_qty} ${item.uom}`
    },
    {
      key: 'total_pack',
      label: 'Qty Kemasan',
      component: (item) => `${item.total_pack} ${item.uom_pack}`
    }
  ]
  const columnStagingArea = [
    {
      key: 'palet_id',
      label: 'Palet',
      component: (item) => `#${item.palet_id}`
    },
    {
      key: 'item_code_name',
      label: 'Item Code - Name',
      component: (item) => `${item.item_code} - ${item.item_name}`
    },
    { key: 'batch', label: 'Batch' },
    {
      key: 'total_pack',
      label: 'Qty Kemasan',
      component: (item) => `${item.total_pack} ${item.uom_pack}`
    },
    { key: 'location', label: 'Location' },
    { key: 'dest_area', label: 'Destination Area' },
    {
      key: 'action',
      label: 'Label',
      component: (item) => (
        <div key={item.id}>
          <Button
            type="button"
            variant={loading.download[item.id] ? 'secondary' : 'warning'}
            className={`${
              !loading.download[item.id] ? 'text-light' : 'opacity-25'
            }`}
            onClick={() => handleDownloadLabel(item.id)}
          >
            <Download size={14} />
          </Button>
        </div>
      )
    }
  ]
  const columnItemReceipts = [
    {
      key: 'item_code_name',
      label: 'Item Code - Name',
      component: (item) => `${item.item_code} - ${item.item_name}`
    },
    { key: 'batch', label: 'Batch' },
    {
      key: 'total_pack',
      label: 'Quarantine Pack',
      component: (item) => `${item.total_pack} ${item.uom_pack}`
    },
    {
      key: 'total_qty',
      label: 'Quarantine qty',
      component: (item) => `${item.total_qty} ${item.uom}`
    }
  ]
  const handleModalTimeline = () => {
    const show = !showModalTimeline
    setShowModalTimeline(show)
    if (!show) {
      setPrTimelineId(null)
    }
  }
  const fetchDetail = async () => {
    try {
      setLoading((prev) => ({
        ...prev,
        page: true
      }))
      const res = await api.get(`/inbound/return/${id}`)
      const { data } = res
      if (data.success) {
        const { data: dataResponse } = data
        setData(dataResponse)
      }
    } catch (error) {
      const errMsg =
        error?.response?.data?.errors?.message ||
        error?.message ||
        'An error occurred'
      Common.showPopUpErrorMessage(errMsg)
      navigate('/inbound/inbound-return', { state: { state } })
    } finally {
      setLoading((prev) => ({
        ...prev,
        page: false
      }))
    }
  }
  const handleSubmitAndSendErp = () => {
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: 'btn btn-primary-orange',
        cancelButton: 'btn btn-transparent',
        actions:
          'd-flex w-100 justify-content-end pt-4 ps-4 pe-4 separator-border-action-sweetalert'
      },
      buttonsStyling: false
    })
    swalWithBootstrapButtons
      .fire({
        title: 'Send to ERP?',
        text: 'This action can’t be repeated!',
        icon: 'warning',
        iconColor: '#828282',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Send',
        cancelButtonText: 'Cancel',
        allowOutsideClick: false,
        reverseButtons: true,
        showCloseButton: true
      })
      .then(async (result) => {
        if (result.isConfirmed) {
          try {
            const res = await api.post(`/inbound/return/${data?.id}/send-erp`)
            if (res.data.success) {
              Swal.close()
              // load data
              fetchDetail()
              toast.success('Success', {
                position: 'top-right',
                style: {
                  fontSize: '14px',
                  fontWeight: '600'
                }
              })
            }
          } catch (err) {
            Swal.close()
            const errMsg =
              err?.response?.data?.errors?.message || 'An error occurred'
            const swalWithBootstrapButtonError = Swal.mixin({
              customClass: {
                confirmButton: 'btn btn-primary-orange',
                cancelButton: 'btn btn-transparent',
                actions:
                  'd-flex w-100 justify-content-end pt-4 ps-4 pe-4 separator-border-action-sweetalert'
              },
              buttonsStyling: false
            })
            swalWithBootstrapButtonError
              .fire({
                html: `<p>Send to ERP <span class='text-danger fw-bold text-uppercase'>failed</span></p><br><p>Reason: ${errMsg}</p>`,
                icon: 'error',
                showCancelButton: false,
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'Resend',
                allowOutsideClick: false,
                showCloseButton: true
              })
              .then(async (result) => {
                if (result.isConfirmed) {
                  try {
                    const res = await api.post(
                      `inbound/ml-draft/${data?.id}/assign-area`
                    )
                    if (res.data.success) {
                      Swal.close()
                      // load data
                      fetchDetail()
                      toast.success('Success', {
                        position: 'top-right',
                        style: {
                          fontSize: '14px',
                          fontWeight: '600'
                        }
                      })
                    }
                  } catch (err) {
                    Swal.close()
                    const errMsg =
                      err?.response?.data?.errors?.message ||
                      'An error occurred'
                    Common.showPopUpErrorMessage(errMsg)
                  }
                }
              })
          }
        } else {
          return false
        }
      })
  }

  useEffect(() => {
    if (id) {
      fetchDetail()
    }
  }, [id])

  if (loading.page) {
    return <Loading />
  }

  return (
    <Container>
      <Toaster />
      <Row>
        <Col md={12}>
          <div className="d-flex justify-content-between">
            <div className="d-flex flex-column justify-content-start">
              <h6 className="header-title-style" style={{ fontSize: '18px' }}>
                {data?.code}{' '}
                <sup>
                  <BadgeStatusPrLists
                    text={statusTextMapping[data?.status] || 'done'}
                  />
                </sup>
              </h6>
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb fs-6">
                  <li className="breadcrumb-item">
                    <Link
                      to="/inbound/inbound-return"
                      state={state}
                      className="text-decoration-none"
                    >
                      <span className="text-black fw-bold text-uppercase">
                        IR
                      </span>
                    </Link>
                  </li>
                  <li
                    className="breadcrumb-item sj-item active"
                    aria-current="page"
                  >
                    {data?.code || ''}
                  </li>
                </ol>
              </nav>
            </div>
          </div>
        </Col>
      </Row>
      <Row>
        <Col xs={12} md={12} lg={12}>
          <Card style={cardStyle}>
            <Row>
              <StyledDetailField
                label="series"
                value={data?.series_number || ''}
                col={3}
              />
              <StyledDetailField
                label="#ERP DOC NO"
                value={data?.erp_doc || '-'}
                col={3}
              />
              <StyledDetailField
                label="target warehouse"
                value={data?.target_warehouse || ''}
                col={3}
              />
              <StyledDetailField label="#RR" value={data?.rr || ''} col={3} />
              <StyledDetailField
                label="car"
                value={data?.vehicle || ''}
                col={3}
              />
              <StyledDetailField
                label="driver"
                value={data?.driver || ''}
                col={3}
              />
            </Row>
          </Card>
        </Col>
      </Row>
      <Row>
        <Col xs={12} md={12} lg={12}>
          <Card style={cardStyle}>
            <Row className="mb-3">
              <Col md={12} className="mb-2">
                <div className="d-flex justify-content-between align-items-center">
                  <h5 className="text-secondary" style={{ margin: 0 }}>
                    Item & COA
                  </h5>
                  <Button
                    variant="transparent"
                    className="p-0"
                    style={{ marginTop: '-0.2rem' }}
                  >
                    {itemCoaCollapse ? (
                      <ChevronUp
                        size={16}
                        className="ms-1"
                        onClick={() => setItemCoaCollapse(!itemCoaCollapse)}
                        style={{ cursor: 'pointer' }}
                      />
                    ) : (
                      <ChevronDown
                        size={16}
                        className="ms-1"
                        onClick={() => setItemCoaCollapse(!itemCoaCollapse)}
                        style={{ cursor: 'pointer' }}
                      />
                    )}
                  </Button>
                </div>
              </Col>
              <Collapse in={itemCoaCollapse}>
                <div>
                  <Row>
                    <Col md={12}>
                      <Table responsive>
                        <thead className="table-secondary">
                          <tr>
                            {columnItemCOA.map((column) => (
                              <th
                                className="align-middle p-2"
                                key={column.key}
                                style={tableHeaderStyle}
                              >
                                <span>{column.label}</span>
                              </th>
                            ))}
                          </tr>
                        </thead>
                        <tbody>
                          {data?.items?.length === 0 && (
                            <tr>
                              <td
                                colSpan={columnItemCOA.length}
                                className="p-2"
                              >
                                <div className="d-flex justify-content-center">
                                  <span className="text-secondary">
                                    No data available
                                  </span>
                                </div>
                              </td>
                            </tr>
                          )}
                          {data?.items?.length > 0 &&
                            data?.items?.map((item, index) => (
                              <tr key={`${item.id}-${index}`}>
                                {columnItemCOA.map((column) => (
                                  <td
                                    key={column.key}
                                    className="p-2 align-middle"
                                  >
                                    {column.key === 'sequence' && index + 1}
                                    {column.component && column.component(item)}
                                    {!column.component && item[column.key]}
                                  </td>
                                ))}
                              </tr>
                            ))}
                        </tbody>
                      </Table>
                    </Col>
                  </Row>
                </div>
              </Collapse>
            </Row>
          </Card>
        </Col>
      </Row>
      <div className="mt-4">
        {data?.stagings?.length > 0 &&
          data?.stagings
            ?.filter((stagingFilter) => stagingFilter?.items?.length > 0)
            .map((stagingArea, index) => (
              <Card style={cardStyle} key={`${stagingArea.id}-${index}`}>
                <Row>
                  <Col md={12} className="mb-3">
                    <div className="d-flex justify-content-between">
                      <div className="d-flex gap-2 align-items-center">
                        <History
                          size={14}
                          style={{
                            color: '#828282'
                          }}
                          className="cursor-pointer"
                          role="button"
                          onClick={() => {
                            handleModalTimeline()
                            setPrTimelineId(stagingArea.id)
                          }}
                        />
                        <h6 className="fw-bold text-uppercase mb-0">
                          {stagingArea.staging || ''}
                        </h6>
                      </div>
                      <div className="d-flex justify-content-end item-center gap-2">
                        <h6 className="fw-bold mb-0">
                          {stagingArea?.status === 'unassigned'
                            ? ''
                            : `${data?.driver} • `}
                          <span className="text-uppercase">
                            {stagingArea?.status
                              ? stagingArea?.status?.replaceAll('_', ' ')
                              : '-'}
                          </span>
                        </h6>
                        <FileText size={16} color="#828282" />
                      </div>
                    </div>
                  </Col>
                  <Col md={12}>
                    <Table responsive>
                      <thead className="table-secondary">
                        <tr>
                          {columnStagingArea.map((column) => (
                            <th
                              className="align-middle p-2"
                              key={column.key}
                              style={tableHeaderStyle}
                            >
                              <span>{column.label}</span>
                            </th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {stagingArea?.items?.length === 0 && (
                          <tr>
                            <td
                              colSpan={columnStagingArea.length}
                              className="p-2"
                            >
                              <div className="d-flex justify-content-center">
                                <span className="text-secondary">
                                  No data available
                                </span>
                              </div>
                            </td>
                          </tr>
                        )}
                        {stagingArea?.items?.length > 0 &&
                          stagingArea?.items?.map((item, index) => (
                            <tr key={`${item.id}-${index}`}>
                              {columnStagingArea.map((column) => (
                                <td
                                  key={column.key}
                                  className="p-2 align-middle"
                                >
                                  {column.key === 'sequence' && index + 1}
                                  {column.component && column.component(item)}
                                  {!column.component && item[column.key]}
                                </td>
                              ))}
                            </tr>
                          ))}
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              </Card>
            ))}
      </div>
      {(data?.status === 'waiting_om' || data?.status === 'request_pnp') && (
        <Row>
          <Col md={12} className="my-3">
            <div className="d-flex justify-content-end">
              <Button
                variant="transparent"
                className="btn-primary-orange fw-bold"
                onClick={() => handleSubmitAndSendErp()}
              >
                Submit & Send to ERP
              </Button>
            </div>
          </Col>
        </Row>
      )}
      <Card style={cardStyle} className="mt-4">
        <Row>
          <Col md={12} className="mb-3">
            <h6 className="fw-bold text-uppercase">Item Receipt Details</h6>
          </Col>
          {data?.receipt_details?.length > 0 &&
            data?.receipt_details?.map((stagingArea, index) => (
              <Col md={12} key={`${stagingArea.id}-${index}`}>
                <Table responsive>
                  <thead className="table-secondary">
                    <tr>
                      {columnItemReceipts.map((column) => (
                        <th
                          className="align-middle p-2"
                          key={column.key}
                          style={tableHeaderStyle}
                        >
                          <span>{column.label}</span>
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {data?.receipt_details?.length === 0 && (
                      <tr>
                        <td colSpan={columnItemReceipts.length} className="p-2">
                          <div className="d-flex justify-content-center">
                            <span className="text-secondary">
                              No data available
                            </span>
                          </div>
                        </td>
                      </tr>
                    )}
                    {data?.receipt_details?.length > 0 &&
                      data?.receipt_details?.map((item, index) => (
                        <tr key={`${item.id}-${index}`}>
                          {columnItemReceipts.map((column) => (
                            <td key={column.key} className="p-2 align-middle">
                              {column.key === 'sequence' && index + 1}
                              {column.component && column.component(item)}
                              {!column.component && item[column.key]}
                            </td>
                          ))}
                        </tr>
                      ))}
                  </tbody>
                </Table>
              </Col>
            ))}
        </Row>
      </Card>
      <Card style={cardStyle} className="mt-4">
        <Row>
          <StyledDetailField
            label="CREATED BY"
            value={data?.created_by ?? '-'}
            col={3}
          />
          <StyledDetailField
            label="CREATED AT"
            value={convertDateWithTime(data?.created_at)}
            col={3}
          />
          <StyledDetailField
            label="LAST UPDATED BY"
            value={data?.updated_by ?? '-'}
            col={3}
          />
          <StyledDetailField
            label="LAST UPDATED AT"
            value={convertDateWithTime(data?.updated_at)}
            col={3}
          />
        </Row>
      </Card>
      <ModalPrDetailTimeline
        show={showModalTimeline}
        timelineId={prTimelineId}
        type="ir"
        onHide={handleModalTimeline}
        irId={data?.id}
      />
    </Container>
  )
}

export default InboundReturnDetail
